import { mapGetters } from 'vuex';
import Contract from '@/models/contract';
import { isMarketSingle, isMarketSettled } from '@/utils/helpers';
import marketSharesBar from '@/components/market/market-shares-bar/market-shares-bar.vue';

export default {
  props: {
    market: {},
    contract: {},
    hideSharesBar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    marketSharesBar,
  },
  computed: {
    ...mapGetters('app', ['currentPriceSymbol', 'isLayoutMobile']),
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    contractModel() {
      return this.contract ? new Contract(this.contract) : {};
    },
    imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-extended-betslip-contract-info/purchase-extended-betslip-contract-info.js